import classNames from "classnames"
import React from "react"

type Props = {
  width?: string
  height?: string
  className?: string
}

const FilterIcon = ({ width = "25px", height = "25px", className }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("shrink-0", className)}
    >
      <path
        d="M21.5 7.5H13.82C13.43 5.79 11.92 4.5 10.11 4.5C8.3 4.5 6.79 5.79 6.4 7.5H3.5C3.09 7.5 2.75 7.84 2.75 8.25C2.75 8.66 3.09 9 3.5 9H6.4C6.79 10.71 8.3 12 10.11 12C11.92 12 13.43 10.71 13.82 9H21.5C21.91 9 22.25 8.66 22.25 8.25C22.25 7.84 21.91 7.5 21.5 7.5ZM10.11 10.5C8.87 10.5 7.86 9.49 7.86 8.25C7.86 7.01 8.87 6 10.11 6C11.35 6 12.36 7.01 12.36 8.25C12.36 9.49 11.35 10.5 10.11 10.5Z"
        fill="currentColor"
      />
      <path
        d="M21.5 16H18.6C18.21 14.29 16.7 13 14.89 13C13.08 13 11.57 14.29 11.18 16H3.5C3.09 16 2.75 16.34 2.75 16.75C2.75 17.16 3.09 17.5 3.5 17.5H11.18C11.57 19.21 13.08 20.5 14.89 20.5C16.7 20.5 18.21 19.21 18.6 17.5H21.5C21.91 17.5 22.25 17.16 22.25 17.75C22.25 17.34 21.91 17 21.5 16ZM14.89 19C13.65 19 12.64 17.99 12.64 16.75C12.64 15.51 13.65 14.5 14.89 14.5C16.13 14.5 17.14 15.51 17.14 16.75C17.14 17.99 16.13 19 14.89 19Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default FilterIcon
